import React from 'react'
import '../styles/Developer.styles.css'
import videoR1 from '../assets/video1.mp4'
import ReactPlayer from 'react-player'
import LogoRosmo from '../assets/logo.png'
import { useOnScreen } from "../hooks/useOnScreen";

export default function Developer() {
  const [ref, isVisible] = useOnScreen({ threshold: 0.5 });
  return (
    <section className='developer' id='desarrolladora'>
      <div className='dv-container'>
        <div className='contVdIm' >
          <div className='divVideo'>
            <div className='containerVideo'>
              <div className='videoPrincipal'>
                <div className='divTxtV'>
                  <p>
                    Fraccionamientos diseñados para la vida en comunidad
                  </p>
                </div> 
              </div>
              <div className='watermark'>
                <img className={'watermark-logo'} src={LogoRosmo} alt='ROSMO-LOGO' />
              </div>
              <ReactPlayer
                id='rosmo-video'
                className="react-player"
                playing={true}
                playbackRate={2}
                muted={true}
                src={videoR1}
                width="100%"
                height="90%"
                style={{objectFit:"fill",borderRadius:"20px"}}
                controls={false}
                loop={true}
              />
            </div>
          </div>
          <div className='containerImg'>
            <div className='imgDev' >
              <div className='divUpImg'>
                <div  ref={ref} className={`divCapDev ${isVisible?"is-visible":""}`}>
                  <p>
                    Desarrollo de proyectos personalizados y funcionales
                  </p>
                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </section>
  )
}


